import React, { Component } from 'react'
import request from '../../../lib/requester'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import moment from 'moment'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ClaimSummaryCHD extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataTable: [],
      baseTable: [],
      selectedClaim: [],
      lovProgram: [],
      loading: false,
      user: JSON.parse(window.localStorage.getItem('is_user')) || {},
      success: '',
      error: [],
      Payment_GL_Date: new Date(),
      Payment_Invoice_No: '',
      selectedProgram: '',
      selectAll: false
    }
  }

  componentDidMount = () => {
    this.getProgram()
  }

  handleChangeProgram = (e) => {
    let value = e.target.value
    this.setState({ selectedProgram: value })
  }
  
  getProgram = () => {
    let url = '/api/traces_chd/v1/payment/list-program'
    let param = {}
    this.setState({ loading: true })

    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ lovProgram: data, loading: false })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  setInvoiceNumber = () => {
    let url = '/api/traces_chd/v1/payment/get-invoice-number'

    this.setState({ loading: true })
    request.getCHD(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({ loading: false, Payment_Invoice_No: data })
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  getDataSummary = (programId) => {
    let url = '/api/traces_chd/v1/payment/list?programId=' + (programId || '')

    this.setState({ loading: true })
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({ dataTable: data, baseTable: data, loading: false, success: '' })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  handleSelectClaim = (value) => {
    let { selectedClaim, dataTable } = this.state;
    let findIndex = _.findIndex(selectedClaim, function (o) {
      return parseInt(o.claim_id) === parseInt(value);
    });
    if (findIndex < 0) {
      let claimDetail = _.find(dataTable, function (o) {
        return parseInt(o.claim_id) === parseInt(value);
      });
      if (claimDetail) {
        // selectedClaim.push(claimDetail);
        selectedClaim.push({
          claim_id: claimDetail.claim_id,
          claim_number: claimDetail.claim_number,
          rejected_by: claimDetail.rejected_by
        })
      }
    } else {
      selectedClaim.splice(findIndex, 1);
    }
    this.setState(selectedClaim);
  };

  handleSelectAll = (e) => {
    let checked = e.target.checked
    let tempDataTable = []
    if (checked) {
      this.state.dataTable.forEach((item, index) => {
        // tempDataTable.push(item)
        tempDataTable.push({
          claim_id: item.claim_id,
          claim_number: item.claim_number,
          rejected_by: item.rejected_by
        })
      });
    }

    this.setState({ 
      selectedClaim: tempDataTable,
      selectAll: checked
    })
    
    let app = this
    window.setTimeout(() => {
      console.log(app.state.selectedClaim)
    }, 200)
  }

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: (
            <input
              type="checkbox"
              onChange={(e) => { this.handleSelectAll(e) }}
              checked={this.state.selectAll}
            />
          ),
          accessor: 'claim_id',
          width: 50,
          Cell: (row) => {
            let findIndex = _.findIndex(app.state.selectedClaim, function (o) {
              return parseInt(o.claim_id) === parseInt(row.value);
            });
            let checked = findIndex >= 0 ? true : false;
            return (
              <span>
                <input
                  type="checkbox"
                  value={row.value}
                  onChange={() => { app.handleSelectClaim(row.value) }}
                  checked={checked}
                />
              </span>
            )
          }
        },
        {
          Header: 'CLAIM NO',
          accessor: 'claim_number',
          filterable: true
        },
        {
          Header: 'PROGRAM NO',
          accessor: 'program_number',
          filterable: true
        },
        {
          Header: 'REFF NO',
          accessor: 'ref_number',
          filterable: true
        },
        {
          Header: 'PROGRAM TYPE',
          accessor: 'program_type',
          filterable: true
        },
        {
          Header: 'PROGRAM DESC',
          accessor: 'description',
          filterable: true
        },
        {
          Header: 'AMOUNT',
          accessor: 'total',
          filterable: true,
          className: 'text-right',
          Cell: function (row) {
            return (
              <span>{row.value ? row.value.toLocaleString('de-DE', { minimumFractionDigits: 2 }) : ''}</span>
            )
          }
        },
        {
          Header: 'BANK',
          accessor: 'bank',
          filterable: true
        },
        {
          Header: 'PPH TYPE',
          accessor: 'pph_type',
          filterable: true,
          Cell: (row) => {
            return (<span>{ row.value ? row.value.toString() : ''}</span>)
          }
        },
        {
          Header: 'CLAIM DATE',
          accessor: 'creation_date',
          filterable: true,
          Cell: row => (
            <span>{row.value ? moment(row.value).format('DD-MMM-YYYY HH:mm:ss') : ''}</span>
          )
        },
        {
          Header: '#',
          accessor: 'claim_id',
          filterable: true,
          Cell: row => (
            <span><button type="button" className="btn btn-sm btn-primary" onClick={() => { this.goDetail(row) }}><i className="fa fa-eye" /> View</button></span>
          )
        }
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = ""
        switch (filter.id) {
          case "start_date":
            columnes = row._original.formatted_start_date
            break;
          case "end_date":
            columnes = row._original.formatted_end_date
            break;
          case "claim_exp_date":
            columnes = row._original.formatted_exp_date
            break;
          case "creation_date":
            columnes = row._original.formatted_submitted_date
            break;
          default:
            columnes = row[filter.id]
        }

        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  goDetail = (row) => {
    this.props.history.push('/admin/claim-chd/summary/' + row.value)
  }

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable
    let filename = 'claim-summary-' + moment(new Date()).format('DDMMYYYYHHmmss')

    return (
      <ExcelFile filename={filename} fileExtension="xls" element={(<button className="btn btn-success"><i className="fas fa-file-excel" />Export to excel</button>)}>
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Claim Number" value="claim_number" />
          <ExcelColumn label="Traces Number" value="skp_number" />                    <ExcelColumn label="Skp Number" value="skp_number" />
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          <ExcelColumn label="Claim Exp" value="formatted_claim_exp" />
          <ExcelColumn label="Submitted Date" value="creation_date" />
          <ExcelColumn label="Amount" value="total_claim" />
          <ExcelColumn label="Customer" value="customer_name" />
          <ExcelColumn label="Status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  thousandSeparator = (value) => {
    if (value.length === 0) return

    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  renderSelectedClaim = () => {
    let { selectedClaim } = this.state
    if (selectedClaim.length === 0) {
      return (
        <span className="text-danger"><i><i className="fa fa-exclamation-triangle" /> Select claim to submit</i></span>
      )
    } else {
      let concat = selectedClaim.map((item, index) => {
        return item.claim_number
      })
      return (
        <span>
          <div className="row">
            <div className="col-md-6">
              <span className="text-success"><i><i className="fa fa-check" /> Selected claim:</i></span>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <span>{concat.join(', ')}</span>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-2">
              <button type="button" className="btn btn-success btn-sm btn-block" onClick={this.handleSubmit.bind(this)} ><i className="fa fa-save" /> Submit</button>
            </div>
          </div>
        </span>
      )
    }
  }

  handleSubmit = () => {
    let { selectedClaim, selectedProgram, user } = this.state
    if (selectedClaim.length === 0) {
      alert('Please select claim')
      return false
    }
    if (selectedProgram.length === 0) {
      alert('Please select program')
      return false
    }

    let param = {
      selectedProgram: selectedProgram,
      claim: selectedClaim,
      org_id: user.org_id,
      gl_date: new Date()
    }

    this.setState({ loading: true })
    request.postCHD('/api/traces_chd/v1/payment/submit-oracle', param, {
      success: function (response) {
        let { message } = response.data
        this.setState({ loading: false, success: message || 'Data has been submitted to oracle', selectedClaim: [] })

        let app = this
        window.setTimeout(() => {
          app.getDataSummary()
          app.setInvoiceNumber()
        }, 2000)
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false, error: [e.message || 'Error while submit to oracle, please try again.'] })
      }.bind(this)
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  handleChangeInput = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({ [name]: value });
  }

  handleGLDate = (date) => {
    this.setState({ Payment_GL_Date: date })
  }

  handleClear = () => {
    this.setState({ selectedClaim: [] })
  }

  handleSearch = () => {
    let split = this.state.selectedProgram.split('#')
    let programId = split[3] || '0'

    this.getDataSummary(programId)
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    {this.showNotification()}
                    <div className="row">
                      <div className="col-md-4">
                        <select name="program_desc" className="form-control" onChange={this.handleChangeProgram.bind(this)} value={this.state.selectedProgram}>
                          <option>- Select Program -</option>
                          {
                            this.state.lovProgram.map((item, index) => (
                              <option value={item.program_title + '#' + (moment(item.start_date).format('DD-MMM-YYYY')) + '#' + (moment(item.end_date).format('DD-MMM-YYYY')) + '#' + item.program_id}>{item.program_title}</option>
                            ))
                          }
                        </select>
                      </div>
                      <div className="col-md-2">
                        <button type="button" className="btn btn-primary btn-block" onClick={this.handleSearch.bind(this)}><i className="fa fa-search" /> Find</button>
                      </div>
                      <div className="col-md-2">
                        <button type="button" className="btn btn-success btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-check" /> Process</button>
                      </div>
                      <div className="col-md-2">
                        <button type="button" className="btn btn-warning btn-block" onClick={this.handleClear.bind(this)}><i className="fa fa-times" /> Clear</button>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-12">
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ClaimSummaryCHD